export default "<div>\n  <button (click)=\"logout()\">Logout</button>\n</div>\n";